import { type OpinionResult } from '../../types';
import { ResultsGrid, type ViewType } from '../shared';

import { OpinionsResultCard } from './OpinionsResultCard';

export interface OpinionsResultsProps {
  results: OpinionResult[];
  viewType?: ViewType;
}

export const OpinionsResults = ({
  results,
  viewType = 'grid',
}: OpinionsResultsProps) => (
  <ResultsGrid
    results={results}
    viewType={viewType}
    renderCard={(opinionItem) => (
      <OpinionsResultCard opinionItem={opinionItem} />
    )}
    getKey={(opinionItem, index) => opinionItem.cluster_id || index}
  />
);
